{
  "close": "Schließen",
  "notifications": "Benachrichtigungen"
}
